import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PdfSettingsModel } from '../../models';
import { PdfSettingsAlignEnum } from '../../enums';

@Component({
  selector: 'rnpl-pdf-title',
  templateUrl: './pdf-title.component.html',
  styleUrls: ['./pdf-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PdfTitleComponent {

  @Input() pdfSettings: PdfSettingsModel;
  @Input() currentShortYear: string;

  public alignEnum = PdfSettingsAlignEnum;

}
